import React from 'react';
import AutocompleteSelect from '../shared/AutocompleteSelect';
import ProductRangeFilter from '../pages/AdminProductsPage/ProductRangeFilter';
import { promoSortFields, promoStatuses } from './promoListQuery';
import '../../styles/admin-product-filters.css';

const types = { PERCENT: 'Відсоткова', FIXED_UAH: 'Сума у гривнях' };
const sources = { MANUAL: 'Звичайні промокоди', WHEEL: 'Колесо знижок' };
const scopes = { ALL: 'Усі категорії', SELECTED: 'Обрані категорії' };

export default function PromoCodeFilters({ query, onChange, onReset }) {
  const select = (key, label, options, all = 'Всі') => <div className='ap-filter-choice'>
    <label className='promo-filter-label' htmlFor={`promo-filter-${key}`}>{label}</label>
    <select id={`promo-filter-${key}`} className='form-control' value={query[key]} onChange={event => onChange({ [key]: event.target.value })}>
      {all && <option value=''>{all}</option>}
      {Object.entries(options).map(([value, name]) => <option key={value} value={value}>{name}</option>)}
    </select>
  </div>;
  const chips = [
    ...(query.status.length ? [{ key: 'status', label: `Статус: ${query.status.map(value => promoStatuses[value] || value).join(', ')}`, empty: [] }] : []),
    ...Object.entries({ discountType: 'Тип знижки', campaignSource: 'Джерело акції', categoryScope: 'Категорії', id: 'ID', assignedUserId: 'ID покупця', search: 'Пошук', discountFrom: 'Знижка від', discountTo: 'Знижка до' })
      .filter(([key]) => query[key] !== '').map(([key, name]) => ({ key, label: `${name}: ${({ discountType: types, campaignSource: sources, categoryScope: scopes }[key] || {})[query[key]] || query[key]}`, empty: '' })),
  ];
  const sorted = query.sortBy !== 'id' || query.sortOrder !== 'desc';
  return <section className='ap-product-filters promo-list-filters' aria-label='Фільтри промокодів'>
    <div className='promo-filter-grid mb-3'>
      <div className='ap-filter-choice'>
        <p className='promo-filter-label'>Статус</p>
        <AutocompleteSelect label='Статус промокоду' className='ap-category-autocomplete' overlay summary placeholder='Всі'
          options={Object.entries(promoStatuses).map(([value, label]) => ({ value, label }))} value={query.status} onChange={status => onChange({ status })} />
      </div>
      {select('campaignSource', 'Джерело акції', sources)}
      {select('discountType', 'Тип знижки', types)}
      {select('categoryScope', 'Область дії', scopes, 'Будь-яка')}
      <ProductRangeFilter label='Знижка, % / грн' from={query.discountFrom} to={query.discountTo}
        onFromChange={discountFrom => onChange({ discountFrom })} onToChange={discountTo => onChange({ discountTo })} max={2147483647} />
    </div>
    <div className='promo-filter-search-grid'>
      {['id', 'assignedUserId'].map((key, index) => <div className='ap-filter-choice' key={key}>
        <label className='promo-filter-label' htmlFor={`promo-filter-${key}`}>{index ? 'ID покупця' : 'ID промокоду'}</label>
        <input id={`promo-filter-${key}`} type='number' min='1' step='1' className='form-control' value={query[key]} placeholder='Всі'
          onChange={event => onChange({ [key]: event.target.value })} />
      </div>)}
      <div className='ap-filter-choice promo-filter-search'>
        <label className='promo-filter-label' htmlFor='promo-search'>Пошук за кодом або коментарем</label>
        <div className='position-relative'>
          <input id='promo-search' type='search' className='form-control pr-4' maxLength={120} placeholder='Введіть код або коментар' value={query.search} onChange={event => onChange({ search: event.target.value })} />
          {query.search && <button type='button' className='btn promo-search-clear' aria-label='Очистити пошук' onClick={() => onChange({ search: '' })}><i className='bi bi-x' aria-hidden='true' /></button>}
        </div>
      </div>
      {select('sortBy', 'Сортування', promoSortFields, null)}
      {select('sortOrder', 'Порядок', { asc: 'За зростанням ↑', desc: 'За спаданням ↓' }, null)}
    </div>
    {(chips.length > 0 || sorted) && <div className='d-flex flex-wrap align-items-center justify-content-between mt-2' style={{ gap: '0.5rem' }}>
      <div className='d-flex flex-wrap align-items-center' style={{ gap: '0.5rem' }}>
        {chips.length > 0 && <span className='promo-filter-label mb-0'>Активні фільтри:</span>}
        {chips.map(chip => <span key={chip.key} className='badge badge-dark promo-filter-chip'>{chip.label}
          <button type='button' className='btn p-0 ml-2 border-0 bg-transparent' aria-label={`Скинути ${chip.label}`} onClick={() => onChange({ [chip.key]: chip.empty })}>×</button>
        </span>)}
        {sorted && <span className='badge badge-dark promo-filter-chip'>Сортування: {promoSortFields[query.sortBy] || query.sortBy} {query.sortOrder === 'asc' ? '↑' : '↓'}
          <button type='button' className='btn p-0 ml-2 border-0 bg-transparent' aria-label='Скинути сортування' onClick={() => onChange({ sortBy: 'id', sortOrder: 'desc' })}>×</button>
        </span>}
      </div>
      {(chips.length > 0 || sorted) && <button type='button' className='btn btn-sm btn-outline-secondary' onClick={onReset}><i className='bi bi-arrow-counterclockwise mr-1' aria-hidden='true' />Скинути фільтри</button>}
    </div>}
  </section>;
}
